module.exports = __webpack_public_path__ + "static/media/qa.92deaade.svg";